import { Component } from '@angular/core';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import { merge, Observable, of } from 'rxjs';

import { DcIcons } from '../../app-dc.icons';

enum Status {
	Unpublish = 'unpublished',
	Available = 'available',
	UnAvailable = 'unavailable',
	Running = 'running',
	Waiting = 'waiting',
	Success = 'success',
	Error = 'failed',
	InProgress = 'in-progress',
	Paused = 'paused',
	Absent = 'absent',
	NotUsed = 'not-used',
	Synced = 'synced',
	NotSynced = 'not-synced',
	Unknown = 'unknown',
}

export type StatusType = `${Status}`;

@Component({
	selector: 'app-status-badge',
	templateUrl: './app-status-badge.component.html',
	styleUrls: ['./app-status-badge.component.scss'],
	inputs: ['status'],
})
export class AppStatusBadgeComponent extends DcBaseComponent {
	protected readonly Status = Status;
	protected readonly DcIcons = DcIcons;

	public vo$: Observable<{ status: Status | StatusType }>;

	public constructor() {
		super();
		this.cmpId = 'app-status-badge';

		this.vo$ = combineAll({
			status: merge(
				of(Status.Unpublish),
				this.toObservable<Status | StatusType>('status')
			),
		});
	}
}
